// Motion choreography runtime (Tier 3).
// The `motion` / `childMotion` fields below are Tier 1 token references in the
// form "<duration> <easing>" (e.g. "long emphasized"). They are resolved to real
// values at run time from the CSS custom properties in _variables.scss (see
// resolveMotion), so this file holds no duplicated durations/easings and stays in
// lockstep with the CSS — including the reduced-motion collapse. Offsets/delays
// stay as literal ms since they are choreography timing, not design tokens.

export const choreography = {
  "choreography-list-reveal": {
    "pattern": "stagger",
    "childMotion": "short entrance",
    "childKeyframes": "rise",
    "offset": "100ms",
    "direction": "forward",
    "maxElements": 8,
    "reducedMotion": {
      "collapseTo": "parallel",
      "childMotion": "short entrance",
      "childKeyframes": "fade-in",
      "offset": "0ms"
    }
  },
  "choreography-list-dismiss": {
    "pattern": "stagger",
    "childMotion": "quick exit",
    "childKeyframes": "sink",
    "offset": "60ms",
    "direction": "reverse",
    "maxElements": 8,
    "reducedMotion": {
      "collapseTo": "parallel",
      "childMotion": "quick exit",
      "childKeyframes": "fade-out",
      "offset": "0ms"
    }
  },
  "choreography-menu-reveal": {
    "pattern": "stagger",
    "childMotion": "short entrance",
    "childKeyframes": "rise",
    "offset": "40ms",
    "startDelay": "50ms",
    "direction": "forward",
    "maxElements": 8,
    "reducedMotion": {
      "collapseTo": "parallel",
      "childMotion": "short entrance",
      "childKeyframes": "fade-in",
      "offset": "0ms",
      "startDelay": "0ms"
    }
  },
  "choreography-modal-enter": {
    "pattern": "coordinated",
    "target": ".modal-root",
    "tracks": [
      {
        "selector": ".modal-root",
        "keyframes": "fade-in",
        "motion": "medium entrance",
        "delay": "0ms"
      },
      {
        "selector": ".modal-card",
        "keyframes": "pop",
        "motion": "long emphasized",
        "delay": "100ms"
      }
    ],
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".modal-card",
          "keyframes": "fade-in",
          "motion": "medium entrance",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-modal-exit": {
    "pattern": "coordinated",
    "target": ".modal-root",
    "tracks": [
      {
        "selector": ".modal-card",
        "keyframes": "shrink",
        "motion": "short exit",
        "delay": "0ms"
      },
      {
        "selector": ".modal-root",
        "keyframes": "fade-out",
        "motion": "short exit",
        "delay": "0ms"
      }
    ],
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".modal-card",
          "keyframes": "fade-out",
          "motion": "short exit",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-modal-reveal": {
    "pattern": "coordinated",
    "target": ".c-event-listing__modal",
    "tracks": [
      {
        "selector": ".c-event-listing__modal-overlay",
        "keyframes": "scrim-in",
        "motion": "medium entrance",
        "delay": "0ms"
      },
      {
        "selector": ".c-event-listing__modal-card",
        "keyframes": "pop",
        "motion": "long emphasized",
        "delay": "80ms"
      }
    ],
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".c-event-listing__modal-overlay",
          "keyframes": "scrim-in",
          "motion": "medium entrance",
          "delay": "0ms"
        },
        {
          "selector": ".c-event-listing__modal-card",
          "keyframes": "fade-in",
          "motion": "medium entrance",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-modal-dismiss": {
    "pattern": "coordinated",
    "target": ".c-event-listing__modal",
    "tracks": [
      {
        "selector": ".c-event-listing__modal-card",
        "keyframes": "shrink",
        "motion": "short exit",
        "delay": "0ms"
      },
      {
        "selector": ".c-event-listing__modal-overlay",
        "keyframes": "scrim-out",
        "motion": "short exit",
        "delay": "60ms"
      }
    ],
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".c-event-listing__modal-card",
          "keyframes": "fade-out",
          "motion": "short exit",
          "delay": "0ms"
        },
        {
          "selector": ".c-event-listing__modal-overlay",
          "keyframes": "scrim-out",
          "motion": "short exit",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-social-reveal": {
    "pattern": "stagger",
    "childMotion": "short entrance",
    "childKeyframes": "slide-in",
    "offset": "100ms",
    "startDelay": "400ms",
    "direction": "forward",
    "maxElements": 8,
    "reducedMotion": {
      "collapseTo": "parallel",
      "childMotion": "short entrance",
      "childKeyframes": "fade-in",
      "offset": "0ms",
      "startDelay": "0ms"
    }
  },
  "choreography-social-dismiss": {
    "pattern": "stagger",
    "childMotion": "quick exit",
    "childKeyframes": "slide-out",
    "offset": "60ms",
    "direction": "reverse",
    "maxElements": 8,
    "reducedMotion": {
      "collapseTo": "parallel",
      "childMotion": "quick exit",
      "childKeyframes": "fade-out",
      "offset": "0ms"
    }
  },
  "choreography-mobile-menu-enter": {
    "pattern": "coordinated",
    "target": ".c-mobile-nav-root",
    "tracks": [
      {
        "selector": ".c-mobile-nav-overlay",
        "keyframes": "scrim-in",
        "motion": "medium entrance",
        "delay": "0ms"
      },
      {
        "selector": ".c-mobile-nav",
        "keyframes": "drawer-down",
        "motion": "long emphasized",
        "delay": "0ms"
      }
    ],
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".c-mobile-nav",
          "keyframes": "fade-in",
          "motion": "medium entrance",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-mobile-menu-exit": {
    "pattern": "coordinated",
    "target": ".c-mobile-nav-root",
    "tracks": [
      {
        "selector": ".c-mobile-nav",
        "keyframes": "drawer-up",
        "motion": "short exit",
        "delay": "120ms"
      },
      {
        "selector": ".c-mobile-nav-overlay",
        "keyframes": "scrim-out",
        "motion": "short exit",
        "delay": "160ms"
      }
    ],
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".c-mobile-nav",
          "keyframes": "fade-out",
          "motion": "short exit",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-staff-drawer-enter": {
    "pattern": "coordinated",
    "target": ".c-staff-drawer-root",
    "tracks": [
      {
        "selector": ".c-staff-drawer-overlay",
        "keyframes": "scrim-in",
        "motion": "medium entrance",
        "delay": "0ms"
      },
      {
        "selector": ".c-staff-drawer",
        "keyframes": "drawer-slide-in",
        "motion": "long emphasized",
        "delay": "0ms"
      }
    ],
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".c-staff-drawer-overlay",
          "keyframes": "scrim-in",
          "motion": "medium entrance",
          "delay": "0ms"
        },
        {
          "selector": ".c-staff-drawer",
          "keyframes": "drawer-slide-in",
          "motion": "medium entrance",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-staff-drawer-exit": {
    "pattern": "coordinated",
    "target": ".c-staff-drawer-root",
    "tracks": [
      {
        "selector": ".c-staff-drawer",
        "keyframes": "drawer-slide-out",
        "motion": "short exit",
        "delay": "120ms"
      },
      {
        "selector": ".c-staff-drawer-overlay",
        "keyframes": "scrim-out",
        "motion": "short exit",
        "delay": "160ms"
      }
    ],
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".c-staff-drawer",
          "keyframes": "drawer-slide-out",
          "motion": "short exit",
          "delay": "0ms"
        },
        {
          "selector": ".c-staff-drawer-overlay",
          "keyframes": "scrim-out",
          "motion": "short exit",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-donate-drawer-enter": {
    "pattern": "coordinated",
    "target": ".c-donate-drawer-root",
    "tracks": [
      {
        "selector": ".c-donate-drawer-overlay",
        "keyframes": "scrim-in",
        "motion": "medium entrance",
        "delay": "0ms"
      },
      {
        "selector": ".c-donate-drawer",
        "keyframes": "drawer-slide-in-end",
        "motion": "long emphasized",
        "delay": "0ms"
      }
    ],
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".c-donate-drawer-overlay",
          "keyframes": "scrim-in",
          "motion": "medium entrance",
          "delay": "0ms"
        },
        {
          "selector": ".c-donate-drawer",
          "keyframes": "drawer-slide-in-end",
          "motion": "medium entrance",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-donate-drawer-exit": {
    "pattern": "coordinated",
    "target": ".c-donate-drawer-root",
    "tracks": [
      {
        "selector": ".c-donate-drawer",
        "keyframes": "drawer-slide-out-end",
        "motion": "short exit",
        "delay": "120ms"
      },
      {
        "selector": ".c-donate-drawer-overlay",
        "keyframes": "scrim-out",
        "motion": "short exit",
        "delay": "160ms"
      }
    ],
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".c-donate-drawer",
          "keyframes": "drawer-slide-out-end",
          "motion": "short exit",
          "delay": "0ms"
        },
        {
          "selector": ".c-donate-drawer-overlay",
          "keyframes": "scrim-out",
          "motion": "short exit",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-filter-drawer-enter": {
    "pattern": "coordinated",
    "target": ".c-filter-drawer-root",
    "tracks": [
      {
        "selector": ".c-filter-drawer-overlay",
        "keyframes": "scrim-in",
        "motion": "medium entrance",
        "delay": "0ms"
      },
      {
        "selector": ".c-filter-drawer",
        "keyframes": "sheet-up",
        "motion": "long emphasized",
        "delay": "0ms"
      }
    ],
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".c-filter-drawer-overlay",
          "keyframes": "scrim-in",
          "motion": "medium entrance",
          "delay": "0ms"
        },
        {
          "selector": ".c-filter-drawer",
          "keyframes": "fade-in",
          "motion": "medium entrance",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-filter-drawer-exit": {
    "pattern": "coordinated",
    "target": ".c-filter-drawer-root",
    "tracks": [
      {
        "selector": ".c-filter-drawer",
        "keyframes": "sheet-down",
        "motion": "short exit",
        "delay": "0ms"
      },
      {
        "selector": ".c-filter-drawer-overlay",
        "keyframes": "scrim-out",
        "motion": "short exit",
        "delay": "60ms"
      }
    ],
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".c-filter-drawer",
          "keyframes": "fade-out",
          "motion": "short exit",
          "delay": "0ms"
        },
        {
          "selector": ".c-filter-drawer-overlay",
          "keyframes": "scrim-out",
          "motion": "short exit",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-detail-transition": {
    "pattern": "shared-element",
    "from": ".card-thumbnail",
    "to": ".card-detail",
    "motion": "long emphasized",
    "properties": [
      "transform",
      "border-radius"
    ],
    "fallback": {
      "pattern": "coordinated",
      "tracks": [
        {
          "selector": ".card-detail",
          "keyframes": "pop",
          "motion": "medium entrance",
          "delay": "0ms"
        }
      ]
    },
    "reducedMotion": {
      "collapseTo": "coordinated",
      "tracks": [
        {
          "selector": ".card-detail",
          "keyframes": "fade-in",
          "motion": "medium entrance",
          "delay": "0ms"
        }
      ]
    }
  },
  "choreography-mobile-map-chrome-enter": {
    "pattern": "coordinated",
    "target": ".c-directory__map",
    "tracks": [
      {
        "selector": ".c-directory__mm-header",
        "keyframes": "header-drop-in",
        "motion": "medium entrance",
        "delay": "0ms"
      },
      {
        "selector": ".c-directory__map-list-wrap",
        "keyframes": "sheet-up",
        "motion": "medium entrance",
        "delay": "160ms"
      }
    ]
  },
  "choreography-mobile-map-chrome-exit": {
    "pattern": "coordinated",
    "target": ".c-directory__map",
    "tracks": [
      {
        "selector": ".c-directory__map-list-wrap",
        "keyframes": "sheet-down",
        "motion": "short exit",
        "delay": "0ms"
      },
      {
        "selector": ".c-directory__mm-header",
        "keyframes": "header-drop-out",
        "motion": "short exit",
        "delay": "80ms"
      }
    ]
  },
  "choreography-sheet-out": {
    "pattern": "coordinated",
    "tracks": [
      { "keyframes": "sheet-down", "motion": "medium exit", "delay": "0ms" }
    ]
  },
  "choreography-sheet-in": {
    "pattern": "coordinated",
    "tracks": [
      { "keyframes": "sheet-up", "motion": "long entrance", "delay": "0ms" }
    ]
  },
  "choreography-header-out": {
    "pattern": "coordinated",
    "tracks": [
      { "keyframes": "header-drop-out", "motion": "short exit", "delay": "0ms" }
    ]
  }
};

export const keyframePresets = {
  "fade-in": {
    "opacity": [
      "0",
      "1"
    ]
  },
  "fade-out": {
    "opacity": [
      "1",
      "0"
    ]
  },
  "rise": {
    "opacity": [
      "0",
      "1"
    ],
    "transform": [
      "translateY(8px)",
      "translateY(0)"
    ]
  },
  "sink": {
    "opacity": [
      "1",
      "0"
    ],
    "transform": [
      "translateY(0)",
      "translateY(8px)"
    ]
  },
  "slide-in": {
    "opacity": [
      "0",
      "1"
    ],
    "transform": [
      "translateX(-8px)",
      "translateX(0)"
    ]
  },
  "slide-out": {
    "opacity": [
      "1",
      "0"
    ],
    "transform": [
      "translateX(0)",
      "translateX(-8px)"
    ]
  },
  "pop": {
    "opacity": [
      "0",
      "1"
    ],
    "transform": [
      "scale(0.94)",
      "scale(1)"
    ]
  },
  "shrink": {
    "opacity": [
      "1",
      "0"
    ],
    "transform": [
      "scale(1)",
      "scale(0.96)"
    ]
  },
  "drawer-down": {
    "opacity": [
      "0",
      "1"
    ],
    "transform": [
      "translateY(-6px)",
      "translateY(0)"
    ]
  },
  "drawer-up": {
    "opacity": [
      "1",
      "0"
    ],
    "transform": [
      "translateY(0)",
      "translateY(-6px)"
    ]
  },
  "scrim-in": {
    "background-color": [
      "rgba(0,0,0,0)",
      "rgba(0,0,0,0.34)"
    ]
  },
  "scrim-out": {
    "background-color": [
      "rgba(0,0,0,0.34)",
      "rgba(0,0,0,0)"
    ]
  },
  "drawer-slide-in": {
    "transform": [
      "translateX(-100%)",
      "translateX(0)"
    ]
  },
  "drawer-slide-out": {
    "transform": [
      "translateX(0)",
      "translateX(-100%)"
    ]
  },
  "drawer-slide-in-end": {
    "transform": [
      "translateX(100%)",
      "translateX(0)"
    ]
  },
  "drawer-slide-out-end": {
    "transform": [
      "translateX(0)",
      "translateX(100%)"
    ]
  },
  "sheet-up": {
    "transform": [
      "translateY(100%)",
      "translateY(0)"
    ]
  },
  "sheet-down": {
    "transform": [
      "translateY(0)",
      "translateY(100%)"
    ]
  },
  "header-drop-in": {
    "transform": [
      "translateY(-100%)",
      "translateY(0)"
    ]
  },
  "header-drop-out": {
    "transform": [
      "translateY(0)",
      "translateY(-100%)"
    ]
  }
};

const prefersReduced = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Read a Tier 1 primitive straight from its CSS custom property so the JS runtime
// never duplicates the numbers that live in _variables.scss. This is the single
// source of truth — and because the reduced-motion media query zeroes the
// duration custom properties at :root, those 0ms values flow into WAAPI here for
// free (read fresh each run so a live OS setting change is picked up).
function cssToken(kind, name) {
  if (typeof document === 'undefined') return '';
  return getComputedStyle(document.documentElement)
    .getPropertyValue(`--motion-${kind}-${name}`)
    .trim();
}

// A motion fragment is "<duration-token> <easing-token>" (e.g. "long emphasized"),
// mirroring the CSS Tier 2 composition var(--motion-duration-*) var(--motion-easing-*).
export function resolveMotion(fragment) {
  const [durationName, easingName] = String(fragment).trim().split(/\s+/);
  const duration = cssToken('duration', durationName);
  const easing = cssToken('easing', easingName);
  if (!duration || !easing) {
    console.warn('[motion] unresolved token fragment:', fragment);
  }
  return { duration: duration || '0ms', easing: easing || 'linear' };
}
export function toMs(d) { return parseFloat(d) * (String(d).includes('ms') ? 1 : 1000); }

// Turn a CSS "cubic-bezier(x1,y1,x2,y2)" easing token into a sampler f(t)->eased.
// Needed for property tweens WAAPI can't run (e.g. SVG path `d`), so they still
// ride the exact Tier 1 easing curves. Solves x(t)=progress via a few
// Newton-Raphson steps, then evaluates y. Non-bezier tokens fall back to linear.
export function cubicBezierEasing(css) {
  const m = /cubic-bezier\(([^)]+)\)/.exec(String(css));
  if (!m) return (t) => t;
  const [x1, y1, x2, y2] = m[1].split(',').map(Number);
  const bez = (a, b, u) => {
    const c = 3 * a;
    const B = 3 * (b - a) - c;
    const A = 1 - c - B;
    return ((A * u + B) * u + c) * u;
  };
  const slope = (a, b, u) => {
    const c = 3 * a;
    const B = 3 * (b - a) - c;
    const A = 1 - c - B;
    return (3 * A * u + 2 * B) * u + c;
  };
  return (t) => {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    let u = t;
    for (let i = 0; i < 5; i++) {
      const x = bez(x1, x2, u) - t;
      const d = slope(x1, x2, u);
      if (Math.abs(x) < 1e-4 || d === 0) break;
      u -= x / d;
    }
    return bez(y1, y2, u);
  };
}

/**
 * Token-timed rAF tween from 0→1. Duration + easing come from a Tier 2 motion
 * fragment (e.g. "long emphasized"), so a single reduced-motion override at :root
 * collapses the duration to 0 here too — we then jump straight to the end.
 * `onUpdate(eased)` runs each frame; `onFinish` once at the end. Returns a cancel
 * function. For interpolating properties the choreography WAAPI path can't drive.
 */
export function tween(fragment, onUpdate, onFinish) {
  const { duration, easing } = resolveMotion(fragment);
  const ms = toMs(duration);
  const ease = cubicBezierEasing(easing);
  if (!(ms > 0)) {
    onUpdate(1);
    onFinish && onFinish();
    return () => {};
  }
  let raf;
  let start = null;
  const step = (now) => {
    if (start === null) start = now;
    const t = Math.min(1, (now - start) / ms);
    onUpdate(ease(t));
    if (t < 1) raf = requestAnimationFrame(step);
    else onFinish && onFinish();
  };
  raf = requestAnimationFrame(step);
  return () => cancelAnimationFrame(raf);
}

// Turn a named keyframe preset into a WAAPI keyframe array.
// { opacity:[0,1], transform:['scale(.94)','scale(1)'] } -> [{opacity:0,transform:..},{opacity:1,transform:..}]
function framesFromPreset(name) {
  const preset = keyframePresets[name];
  if (!preset) throw new Error('Unknown keyframe preset: ' + name);
  const from = {}, to = {};
  for (const prop of Object.keys(preset)) {
    const camel = prop.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
    from[camel] = preset[prop][0];
    to[camel] = preset[prop][1];
  }
  return [from, to];
}

const ORDER = {
  forward: (n) => [...Array(n).keys()],
  reverse: (n) => [...Array(n).keys()].reverse(),
  'center-out': (n) => { const c=(n-1)/2; return [...Array(n).keys()].sort((a,b)=>Math.abs(a-c)-Math.abs(b-c)); },
  'edges-in': (n) => { const c=(n-1)/2; return [...Array(n).keys()].sort((a,b)=>Math.abs(b-c)-Math.abs(a-c)); }
};

function runStaggerOrParallel(spec, root) {
  const items = [...root.children].slice(0, spec.maxElements || Infinity);
  const { duration, easing } = resolveMotion(spec.childMotion);
  const frames = framesFromPreset(spec.childKeyframes);
  const offset = spec.pattern === 'parallel' ? 0 : toMs(spec.offset || '0ms');
  // Optional lead-in before the first child. fill: 'both' holds the from-keyframe
  // through the delay, so items stay hidden (no pop) until the stagger begins.
  const startDelay = toMs(spec.startDelay || '0ms');
  const order = (ORDER[spec.direction] || ORDER.forward)(items.length);
  return Promise.all(order.map((idx, i) => {
    const a = items[idx].animate(frames, { duration: toMs(duration), easing, delay: startDelay + i * offset, fill: 'both' });
    return a.finished.catch(() => {});
  }));
}

function runCoordinated(spec, root) {
  return Promise.all(spec.tracks.map(track => {
    const { duration, easing } = resolveMotion(track.motion);
    const delay = toMs(track.delay || '0ms');
    const frames = framesFromPreset(track.keyframes);
    const target = track.selector
      ? (root.matches?.(track.selector) ? root : root.querySelector(track.selector) || root)
      : root;
    const a = target.animate(frames, { duration: toMs(duration), easing, delay, fill: 'both' });
    return a.finished.catch(() => {});
  }));
}

/**
 * Run a choreography token by name against a root element.
 * Fully token-driven: every value comes from the resolved token + keyframe presets.
 * Honors reduced motion by swapping in the token's reducedMotion strategy.
 */
export function run(name, root) {
  let spec = choreography[name];
  if (!spec) throw new Error('Unknown choreography: ' + name);
  if (prefersReduced() && spec.reducedMotion) {
    spec = { ...spec, ...spec.reducedMotion, pattern: spec.reducedMotion.collapseTo };
  }

  switch (spec.pattern) {
    case 'stagger':
    case 'parallel':
      return runStaggerOrParallel(spec, root);
    case 'coordinated':
      return runCoordinated(spec, root);
    case 'shared-element':
      if (typeof document !== 'undefined' && document.startViewTransition) {
        return document.startViewTransition(() => {}).finished.catch(() => {});
      }
      // Fallback: run the token's fallback coordinated spec.
      if (spec.fallback) return runCoordinated(spec.fallback, root);
      return Promise.resolve();
    default:
      throw new Error('Unknown pattern: ' + spec.pattern);
  }
}
